import React, { useEffect } from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { getCarts } from "./actions/initApp";
import { getCustomerProfile } from "./actions/getCustomerProfile";
import { defaultAction } from "./actions/defaultAction";
import TagManager from "react-gtm-module";
import {
  CART_BUY_HIDE_POPUP_CART,
  SET_SLICK_DEALS_SDTID,
  SET_BURGER_MENU
} from "./constants/actionTypes";
import { loadScripts } from "@helpers/loadScripts";
import "./styles/animateInUse.scss";
import "./styles/bootstrap.scss";
import "./styles/modals.scss";
import "./styles/quickBuy.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { sendBugsnagError } from "@utils/Bugsnag";

const InitialNonEssenScripts = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const config = useSelector(state => state.config);
  const sellOrderInProcess = useSelector(
    state => state.initAppReducer.sellOrderInProcess
  );
  const country = useSelector(state => state.ipInfo.country);

  const handleVisibilityChange = () => {
    try {
      const dontRefreshArray = ["order-complete", "receipt"];
      const currentLocation = history?.location?.pathname?.replaceAll
        ? history.location?.pathname?.replaceAll("/", "")
        : "";

      if (dontRefreshArray.includes(currentLocation) || sellOrderInProcess)
        return;
      const status = document.visibilityState;
      if (status === "visible") {
        if (window?.navigator?.onLine) {
          getCustomerInfo();
        } else {
          window.addEventListener("online", getCustomerInfo);
        }
      }
    } catch (error) {
      sendBugsnagError(error, "initialNonEssen/handleVisibilityChange", {
        history
      });
    }
  };

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-W9DCK3"
    };
    TagManager.initialize(tagManagerArgs);
    Bugsnag.start({
      autoTrackSessions: false,
      releaseStage: config.devMode,
      enabledBreadcrumbTypes: [
        "error",
        "request",
        "state",
        "navigation",
        "user"
      ],
      apiKey: "5dbae6043b98a3cbb8856574239bd85d",
      appVersion: config.npm_package_version,
      enabledReleaseStages: ["production", "integration"],
      maxBreadcrumbs: 100,
      maxEvents: 50,
      plugins: [new BugsnagPluginReact()],
      onError: event => {
        if (
          (country && country.toLowerCase() !== "us") ||
          event.device.locale !== "en-US"
        ) {
          return false;
        }
      }
    });
    global.Bugsnag = Bugsnag;
    Bugsnag.startSession();

    var query = {};
    let str = window?.location?.search.slice(1);
    str.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
      query[decodeURIComponent(key)] = decodeURIComponent(value);
    });

    if (query.utm_source) {
      if (query.sdtid) {
        dispatch(defaultAction(SET_SLICK_DEALS_SDTID, query.sdtid));
      }
    }

    (function (i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r;
      (i[r] =
        i[r] ||
        function () {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://www.google-analytics.com/analytics.js",
      "ga"
    );

    ga("create", config.ga, "auto");
    ga("send", "pageview");

    history.listen(location => {
      window.scrollTo(0, 0);
      if (typeof RISKX !== "undefined") {
        RISKX.go(window.location.pathname);
      }
      ga("set", "page", window.location.pathname);
      ga("send", "pageview");
      global._sift && _sift.push(["_trackPageview", location]);
      dispatch(defaultAction(CART_BUY_HIDE_POPUP_CART));
      dispatch(defaultAction(SET_BURGER_MENU, false));
    });

    document.addEventListener("visibilitychange", handleVisibilityChange);

    loadScripts("https://shareasale-analytics.com/j.js", "shareASale");
    loadScripts(
      "https://cdn.jsdelivr.net/sharer.js/latest/sharer.min.js",
      "jsDeliverTag"
    );
    if (config.devMode === "production") {
      setTimeout(() => {
        loadScripts("//load.sumome.com/", "sumoTag", null, [
          {
            attName: "data-sumo-site-id",
            attValue:
              "15e4b3e3962aedbfcaa4d8d066a3336d5ed1d9ce8b46fecfa647a590b8248b7e"
          }
        ]);
      }, 10000);
    }
  }, []);

  const getCustomerInfo = () => {
    dispatch(getCustomerProfile("no-actions"));
    dispatch(getCarts("no-actions"));
    window.removeEventListener("online", getCustomerInfo);
  };

  return <></>;
};
export default InitialNonEssenScripts;
